import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import axios from 'axios'

import menu from './modules/menu'
import app from './modules/app'

import * as getters from './getters'

Vue.use(Vuex)
// Version Check
const appVersion = process.env.DB_VERSION
const appDBKey = process.env.LOCAL_DB_KEY
var dbVersion = window.localStorage.getItem(appDBKey + '_v')

if (dbVersion !== appVersion) {
  window.localStorage.setItem(appDBKey, '')
  window.localStorage.setItem(appDBKey + '_v', appVersion)
}

const vuexLocalStorage = new VuexPersist({
  key: appDBKey, // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
})

// if(true) window.localStorage.clear()

const store = new Vuex.Store({
  strict: false,  // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    menu,
    app
  },
  state: {
    user: false,
    popup: false,
    settings: {
      appname: 'AppTitle'
    },
    token: false
  },
  mutations: {
    logout (state) {
      state.user = false
      state.token = false
      axios.defaults.headers.common['Authorization'] = null
    },
    clean (state) {
      state.user = false
      state.token = false
      axios.defaults.headers.common['Authorization'] = null
    },
    login (state, o) {
      state.user = o.user
      state.token = o.token
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token
    },
    popup (state) {
      state.popup = true
    },
    refresh (state, o) {
      state.user = o
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token
    },
    appsettings (state, o) {
      state.settings = o
    }
  },
  plugins: [vuexLocalStorage.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js